import axios from 'axios';
import customAxios from '@/utils/custom-axios';
import { v4 as uuidv4 } from 'uuid';
import {doctorNameCreator} from '@/utils/doctor';
import {BATCH_SIZE} from "@/reference/app-constants";

const patientAccountApi = `${process.env.VUE_APP_API}/patient/account`;

export const CLAIM_REQUEST_RESULT = {
  NO_CONTACT_INFO: -7,
  INVALID_INVITE_CODE: -6,
  NEED_RELOGIN: -5,
  NOT_CLAIMED: -4,
  RECENT_VERIFICATION: -1,
  CLAIM_FAILED: 0,
  SUCCESS: 1,
  PENDING_VERIFICATION: 2,
  ALREADY_CLAIMED: 3,
};

export const DELETE_PATIENT_RESULT = {
  NOT_EXISTS: -1,
  FAILED: 0,
  SUCCESS: 1,
};

export const UPDATE_MOBILE_EMAIL_RESULT = {
  ALREADY_EXISTS: -1,
  FAILED: 0,
  SUCCESS: 1,
};

export const AccountService = {
  getAccount: () => {
    return customAxios.get(
      patientAccountApi,
    );
  },
  claimRequest: (payload) => {
    return customAxios.post(
      `${patientAccountApi}/claim/request`,
      payload,
    );
  },
  getInviteCodeToken: (code) => {
    return customAxios.post(`${patientAccountApi}/invitecode/`, {code});
  },
  getAccountDoctors: (accessToken) => {
    return axios.post(
      `${process.env.VUE_APP_API}/details`,
      {
        apn: 'web',
      },
      {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      },
    );
  },
  getAccountDoctorsBatch: (tokensArray) => {
    return customAxios.post(
        `${process.env.VUE_APP_API}/details/batch`,
        {
          apn: 'web',
          tokens: tokensArray,
        },
    );
  },
  removePatientToken: (token) => {
    return customAxios.delete(
      `${patientAccountApi}/token/${token}`,
      {
        data: {
          fcmtoken: 'web',
        },
      },
    );
  },
  updateAccount: ({firstname, middlename, lastname, birthdate}) => {
    return customAxios.post(
      `${patientAccountApi}/update`,
      {
        firstname,
        middlename,
        lastname,
        birthdate,
      },
    );
  },
  updateAccountMobileNumber: (mobilenumber, updatetoken) => {
    return customAxios.post(
      `${patientAccountApi}/requestupdate/mobile`,
      {
        mobilenumber,
        updatetoken,
      },
    );
  },
  updateAccountEmail: (email, updatetoken) => {
    return customAxios.post(
      `${patientAccountApi}/requestupdate/email`,
      {
        email,
        updatetoken,
      },
    );
  },
};

export const getAccountWithDetailsService = async () => {
  const {data} = await AccountService.getAccount();
  const verifiedTokens = data.tokens
    .filter(({verified}) => !!verified);

  const tokens = [];

  for (let i = 0; i < verifiedTokens.length; i += BATCH_SIZE) {
    const batch = verifiedTokens.slice(i, i + BATCH_SIZE);
    const tokensArray = batch.map(({token}) => token);

    const responses = await AccountService.getAccountDoctorsBatch(tokensArray);
    if (responses.data.result !== 1) break;

    const batchTokens = responses.data.details
      .map((response) => ({response, verifiedToken: verifiedTokens.find(vt => vt.token === response.token)}))
      .filter(({verifiedToken}) => !!verifiedToken)
      .map(({response, verifiedToken}) => {
        return {
          ...verifiedToken,
          doctor: {
            ...response.doctor,
            _fullName: doctorNameCreator(response.doctor.name, response.doctor.provider, response.doctor.hideSalutation),
          },
          patient: response.patient,
          _refId: uuidv4(), // for socket purposes
        };
      });

    tokens.push(...batchTokens);
  }

  return {
    ...data,
    tokens,
  };
};
